import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';

import CorpHeader from '../../components/corpHeader';
import CorpFooter from '../../components/corpFooter';
import CorpNav from '../../components/corpNav';
import Content from './content/index';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        return (
            <div className={styles.layout}>
                <CorpHeader content={content} />
                <CorpNav content={content} />
                <Content content={content} />
                <CorpFooter content={content} />
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
